(() => {
  const updateCounts = root => {
    root.querySelectorAll('[data-editorial-selected]').forEach(counter => {
      const group = counter.closest('[data-bundle-rule-group]');
      const count = String(group.querySelectorAll('[data-bundle-checkbox]:checked').length);
      if (counter.textContent !== count) counter.textContent = count;
    });
  };
  const arrange = (root) => {
    updateCounts(root);
    const quantity = root.querySelector('[id^="Quantity-Form-"]');
    const buttons = root.querySelector('product-form .product-form__buttons');
    const submit = buttons?.querySelector('button[name="add"]');
    if (quantity && submit) {
      let row = buttons.querySelector('.editorial-purchase-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'editorial-purchase-row';
        buttons.insertBefore(row, submit);
      }
      if (quantity.parentElement !== row) row.prepend(quantity);
      if (submit.parentElement !== row) row.append(submit);
    }
    const slot = root.querySelector('[data-editorial-availability-slot]');
    const availability = root.querySelector('miyabi-availability-button');
    if (slot && availability?.status && !slot.contains(availability.status)) slot.append(availability.status);
    root.querySelectorAll('.product-bundle-upsell__heading').forEach(heading => {
      if (heading.dataset.editorialCase) return;
      heading.textContent = heading.textContent.trim().toLowerCase().replace(/(^|[\s-])([a-z])/g, (_, gap, char) => gap + char.toUpperCase());
      heading.dataset.editorialCase = 'true';
    });
  };
  const init = () => {
    document.querySelectorAll('.miyabi-editorial').forEach(root => {
      if (root.dataset.editorialReady) return;
      root.dataset.editorialReady = 'true';
      root.addEventListener('bundle-selection-change', () => updateCounts(root));
      arrange(root);
      const observer = new MutationObserver(() => arrange(root));
      observer.observe(root, {childList:true,subtree:true});
      customElements.whenDefined('miyabi-availability-button').then(() => arrange(root));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
